export default {
	enableMiniPlayer: 
		localStorage.getItem("enableMiniPlayer") === "true" ||
		(localStorage.getItem("enableMiniPlayer") === null
		? true
		: false)
};